var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_svg__clip0)",
    fill: "#021721"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.554 1.928H1.446C.78 1.928.24 2.468.24 3.133v15.662C.241 19.46.781 20 1.446 20h17.108c.665 0 1.205-.54 1.205-1.205V3.133c0-.665-.54-1.205-1.205-1.205zm-.24 16.626H1.686V3.374h16.626v15.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.036 6.747H.964v1.446h18.072V6.747zM5.301 0c-.4 0-.723.324-.723.723v3.855a.723.723 0 101.446 0V.723C6.024.323 5.7 0 5.301 0zM14.94 0c-.4 0-.723.324-.723.723v3.855a.723.723 0 101.446 0V.723c0-.4-.324-.723-.723-.723zM12.771 14.458H7.47a.723.723 0 100 1.446h5.301a.723.723 0 100-1.446zM12.771 11.085H7.47a.723.723 0 100 1.445h5.301a.723.723 0 100-1.445z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgCalendar;